import Vue from 'vue'
import App from './App.vue'

import "bootstrap/dist/css/bootstrap.min.css";

//iimport "mdbvue/lib/css/mdb.min.css";
import "mdbvue/build/css/mdb.css";

import router from './router';
import store from './store';

import Vuelidate from "vuelidate";
import { Notify } from "mdbvue";
import VueCryptojs from "vue-cryptojs"
import { BTable } from 'bootstrap-vue'
import { BPagination } from 'bootstrap-vue'
import { BFormSelect } from 'bootstrap-vue'

Vue.use(Vuelidate);
Vue.use(Notify);
Vue.use(VueCryptojs);

Vue.config.productionTip = false

Vue.component('b-form-select', BFormSelect)
Vue.component('b-pagination', BPagination)
Vue.component('b-table', BTable)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
